/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';
import { NgcErrorModule } from '../error/ngc-error.component';
// JQX Widget
import { jqxDropDownListComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxdropdownlist';

// Control Value Accessor
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgcDropDownListComponent),
    multi: true
};

/**
 * Drop Down List
 */
@Component({
    selector: 'ngc-dropdownlist',
    template: `<jqxDropDownList *ngIf="visible" (onSelect)="listOnSelect($event)" (onUnselect)="listOnUnselect($event)"
                [autoOpen] = "autoOpen"
                [autoDropDownHeight] = "autoDropDownHeight"
                [animationType] = "animationType"
                [checkboxes] = "checkboxes"
                [closeDelay] = "closeDelay"
                [disabled] = "disabled"
                [displayMember] = "displayMember"
                [dropDownHorizontalAlignment] = "dropDownHorizontalAlignment"
                [dropDownVerticalAlignment] = "dropDownVerticalAlignment"
                [dropDownHeight] = "dropDownHeight"
                [dropDownWidth] = "dropDownWidth"
                [enableSelection] = "enableSelection"
                [enableBrowserBoundsDetection] = "enableBrowserBoundsDetection"
                [enableHover] = "enableHover"
                [filterable] = "filterable"
                [filterHeight] = "filterHeight"
                [filterDelay] = "filterDelay"
                [filterPlaceHolder] = "filterPlaceHolder"
                [incrementalSearch] = "incrementalSearch"
                [incrementalSearchDelay] = "incrementalSearchDelay"
                [itemHeight] = "itemHeight"
                [openDelay] = "openDelay"
                [placeHolder] = "placeHolder"
                [popupZIndex] = "popupZIndex"
                [rtl] = "rtl"
                [renderer] = "renderer"
                [selectionRenderer] = "selectionRenderer"
                [searchMode] = "searchMode"
                [scrollBarSize] = "scrollBarSize"
                [source] = "source"
                [selectedIndex] = "selectedIndex"
                [theme] = "theme"
                [template] = "template"
                [valueMember] = "valueMember"
                [width] = "width"
                [height] = "height">
                </jqxDropDownList>
                <ngc-error *ngIf="visible" [value]="error"></ngc-error>
                `,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class NgcDropDownListComponent extends ControlComponent {
    @Input('autoOpen') autoOpen: any;
    @Input('autoDropDownHeight') autoDropDownHeight: any;
    @Input('animationType') animationType: any;
    @Input('checkboxes') checkboxes: any;
    @Input('closeDelay') closeDelay: any;
    @Input('displayMember') displayMember: any;
    @Input('dropDownHorizontalAlignment') dropDownHorizontalAlignment: any;
    @Input('dropDownVerticalAlignment') dropDownVerticalAlignment: any;
    @Input('dropDownHeight') dropDownHeight: any;
    @Input('dropDownWidth') dropDownWidth: any;
    @Input('enableSelection') enableSelection: any;
    @Input('enableBrowserBoundsDetection') enableBrowserBoundsDetection: any;
    @Input('enableHover') enableHover: any;
    @Input('filterable') filterable: any;
    @Input('filterHeight') filterHeight: any;
    @Input('filterDelay') filterDelay: any;
    @Input('filterPlaceHolder') filterPlaceHolder: any;
    @Input('incrementalSearch') incrementalSearch: any;
    @Input('incrementalSearchDelay') incrementalSearchDelay: any;
    @Input('itemHeight') itemHeight: any;
    @Input('openDelay') openDelay: any;
    @Input('placeHolder') placeHolder: any;
    @Input('popupZIndex') popupZIndex: any;
    @Input('rtl') rtl: any;
    @Input('renderer') renderer: any;
    @Input('selectionRenderer') selectionRenderer: any;
    @Input('searchMode') searchMode: any;
    @Input('scrollBarSize') scrollBarSize: any;
    @Input('source') source: any;
    @Input('selectedIndex') selectedIndex: any;
    @Input('theme') theme: any;
    @Input('template') template: any;
    @Input('valueMember') valueMember: any;
    @Input('width') width: any;
    @Input('height') height: any;
    @Input('auto-create') autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    /**
     * On Select
     * 
     * @param Event
     */
    public listOnSelect($e) {
        this.value = $e.args.item.value;
    }

    /**
     * On Unselect
     * 
     * @param Event
     */
    public listOnUnselect($e) {
        if ($e.args.item !== null) {
            this.value = $e.args.item.value;
        }
    }
}

/**
 * Drop Down List Module
 */
@NgModule({
    imports: [CommonModule, NgcErrorModule],
    exports: [NgcDropDownListComponent],
    declarations: [NgcDropDownListComponent, jqxDropDownListComponent]
})
export class NgcDropDownListModule {
}